//import './alteration-list.scss'

import { defineComponent, PropType } from 'vue'

import { Alteration } from "@skinsoft/types"
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import AlterationLine, { ALTERATION_EDITED, DELETE_ALTERATION } from '../../drawing-editor-components/alteration-line'

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAlterationLine: AlterationLine,
    },
    props: {
        alterations: { type: Array as PropType<Alteration[]> },
        readOnly: { type: Boolean },
        existingTitles: {
            type: Array as PropType<String[]>,
            default: () => []
        },
        firstAlterationNumber: {
            type: Number,
            default: 1,
        }
    },
    template: require('./alteration-list.html'),
    data() {
        return {
            DELETE_ALTERATION: DELETE_ALTERATION,
            ALTERATION_EDITED: ALTERATION_EDITED,
        }
    },
})
